import { Route, Switch } from 'react-router-dom';

const NewMediaPages = ({ routes }: any) => {
  return (
    <Switch>
      {routes.map((route: any) => {
        document.title = `Cobli`;

        return <Route key={route.path} path={route.path} exact={route.exact} render={(props) => <route.component {...props} routes={route.routes} />} />;
      })}
    </Switch>
  );
};

export default NewMediaPages;
